<template>
  <div>
    <v-card
      variant="outlined"
      class="ma-3 pa-3 ai-report-entry"
      @click="toAiReport"
    >
      <div class="d-flex align-center justify-space-between ai-report-entry-row">
        <div class="d-flex align-center ai-report-entry-text">
          <img
            src="@/assets/vevo/mascot_peek.png"
            alt="VEVO"
            style="width: 28px; height: 28px; object-fit: contain;"
          />
          <div>
            <div class="text-subtitle-2 font-weight-bold">{{ $t('aiReport.entry.title') }}</div>
            <div class="text-caption text-grey">{{ $t('aiReport.entry.description') }}</div>
          </div>
        </div>
        <v-icon color="primary" class="flex-shrink-0">mdi-chevron-right</v-icon>
      </div>
    </v-card>

    <div class="font-weight-bold pa-4">{{ $t('records.classSelection') }}</div>

    <div v-if="!fetchLoading">
      <v-list>
        <v-list-item
          v-for="(clas, index) in allClass"
          :key="index"
          @click="toClassRecords(clas.classId)"
        >
          <div class="d-flex align-center justify-space-between">
            <div>
              {{ clas.className }}
              <template v-if="myClass && myClass.classId === clas.classId">
                <v-chip color="primary" class="mx-2" outlined small>{{ $t('communication.inChargeClass') }}</v-chip>
              </template>
            </div>

            <div class="d-flex">
              <v-icon>mdi-chevron-right</v-icon>
            </div>
          </div>
        </v-list-item>
      </v-list>
    </div>
    <div v-else>
      <VueLoading :height="'50vh'" />
    </div>
  </div>
</template>
<script lang="ts">
import Vue from 'vue';
import { defineComponent } from "vue";
import { nurseryModule } from '@/store/dataModules/nurseryModule';
import VueLoading from '@/components/pages/Loding.vue';

import LocalDataService from '@/service/LocalDataService';
import { NurseryClassResponse } from 'chaild-api/lib';
import { ClassResponse } from '@/model/Response';

export default defineComponent({
  components: {
    VueLoading,
  },
  data: () => {
    return {
      fetchLoading: false,
    };
  },
  computed: {
    allClass(): NurseryClassResponse[] | null {
      if (nurseryModule.allClasses) {
        // const myClass = this.myClass;
        // if (myClass) {
        //   const allClasses = nurseryModule.allClasses;
        //   const temp = allClasses.find(clas => clas.classId == myClass.classId);
        //   const index = allClasses.findIndex(clas => clas.classId == myClass.classId);
        //   allClasses.splice(index, 1);
        //   if (temp) {
        //     allClasses.unshift(temp);
        //   }
        //   return allClasses;
        // }
        return nurseryModule.allClasses;
      }
      return null;
    },
    myClass(): ClassResponse | null {
      const user = LocalDataService.getUser();
      if (user && Array.isArray(user.nurserySchools) && user.nurserySchools[0]?.class) {
        return user.nurserySchools[0].class;
      }
      return null;
    },
  },

  methods: {
    toClassRecords(classId: number) {
      this.$router.push(`/record/class/${classId}`);
    },
    toAiReport() {
      this.$router.push('/ai-report');
    },
  },

  async mounted() {
    this.fetchLoading = true;
    try {
      const user = LocalDataService.getUser();
      if (user && Array.isArray(user.nurserySchools)) {
        let nurserySchool = user.nurserySchools.find(nursery => nursery.isDefault === true);
        if (!nurserySchool) {
          nurserySchool = user.nurserySchools[0];
        }
        if (nurserySchool) {
          const nurseryId = nurserySchool.nurseryId;
          await nurseryModule.getNurseryClass(nurseryId);
        }
      }
      this.$nextTick(() => {
        this.fetchLoading = false;
      });
    } catch (e) {
      console.log(e);
    } finally {
      this.fetchLoading = false;
    }
  },
});
</script>

<style lang="scss" scoped>
.ai-report-entry {
  cursor: pointer;
}
.ai-report-entry-row {
  width: 100%;
  gap: 0.5rem;
}
.ai-report-entry-text {
  gap: 0.5rem;
  min-width: 0;
}
</style>
